import { merge } from 'lodash-es';
import { environment as shared_environment } from './environment.shared';

const ush_shared = {
  defaultCountry: 'us',
  defaultLanguage: 'en',
  defaultCurrency: 'USD',
  defaultTheme: 'assets/_themes.css',
  oidc: {
    enabled: true,
    node_api_base_url: '/account/api/oidc',
    redirect_enabled: true,
    redirect_url: '/oidc/connect/authorize',
    end_session: '/oidc/connect/endsession',
    app_flow_path: '/oidc/connect/token',
    password_flow_path: '/oidc/connect/token',
    refresh_expires_in_seconds: 86400,
  },
  resortAreaCode: 'USH',
  resortName: 'USH',
  tridionSite: 'ush',
  entitlementDataUrl:
    '/guests/{guestId}/guest-travel-party-member-tickets?resort-area-code={code}&embed=Lineage',
  components: {
    DashboardTicketsComponent: {
      path: '@components/dashboard-tickets-galaxy/dashboard-tickets.component.ts',
    },
  },
  commerceApi: 'occ/v2/b2cportal_ush',
  isRToasterTagEnabled: false,
  siteName: 'USH',
  contentIdTokenUrl: '/oidc/connect/token',
  pageLabelsUrl: '/resort-areas/ush/content-labels',
  qrCodeAPIParam: 'textToEncode',
  qrCodeDomainUrl: 'https://www.universalorlando.com',
  qrCodeAPIUrl: '/webdata/CodeGenerator/QRCodeGen/?factor=8',
  oneTrustHash:
    'sha384-TKdmlzVmoD70HzftTw4WtOzIBL5mNx8mXSRzEvwrWjpIJ7FZ/EuX758yMDWXtRUN',
  config: {
    // prettier-ignore
    createAccount: {
      links:
        '[{\"tridionKey\":\"createAccount.Terms\",\"linkURL\":\"createAccount.termsLink\",\"target\":\"_blank\",\"altText\":\"createAccount.termsAltText\"},{\"tridionKey\":\"createAccount.privacyPolicy\",\"linkURL\":\"createAccount.privacyLink\",\"target\":\"_blank\",\"altText\":\"createAccount.privacyPolicyAltText\"},{\"tridionKey\":\"createAccount.informationcenter\",\"linkURL\":\"createAccount.infoLink\",\"target\":\"_blank\",\"altText\":\"createAccount.informationcenterAltText\"}]',
      checkboxes:
        '[{\"tridionKey\":\"createAccount.agree\",\"defaultValue\":false,\"required\":true,\"id\":\"termCondition\",\"altText\":\"createAccount.agreeAltText\"},{\"tridionKey\":\"createAccount.specialOffers\",\"defaultValue\":true,\"required\":false,\"id\":\"specialOffer\",\"altText\":\"createAccount.specialOffersAltText\"}]',
    },
    dashboard: {
      showDiningReservationLink: true,
      showBuyTicketsLink: true,
      showLinkTicketsLink: true,
      showTicketContent: true,
      showCouponCard: false,
      isNavigate: true,
      showLinkTicketType: false,
      showTicketDetailsCta: false,
      matchIconByUrl: true,
    },
    showContentCallout: false,
    showReEnterPassword: false,
    showEntitlementsInfo: false,
    showPriority: true,
    displayFirstNameFirst: true,
    profileTPMDetails: {
      otherMembers: false,
    },
    showShareQr: false,
    deletingUSHAccount: true,
    isV1_1FeatureEnabled: true,
  },
  isMMDDYYYYFormat: true,
  hideScanIconDesktop: true,
  showPhoneCard: false,
  showCommPrefCard: true,
  showPaymentCard: true,
  showPasswordCard: false,
  showLogoutCard: false,
  showProfileBirthday: false,
  showProfileGender: false,
  showProfileUpdates: false,
  showEdit: false,
  showCreditCardExpDate: false,
  contentIds: {
    GDS_FOOTER_CONTENT_ID: 'GDS-Footer-Utility-USH-ACCOUNT',
    TRIDION_PUBLICATION: 'ush',
    GDS_GLOBAL_NAV_UTILITY_BAR_CONTENT_ID: 'GDS-Main-Nav-Utility-USH-ACCOUNT',
    GDS_GLOBAL_NAV_MEGA_NAV_CONTENT_ID:
      'gds-global-nav-ush-mega-nav-main-account',
  },
  showCreditCardDetails: true,
  subTotalTaxIncluded: false,
  showTaxLabel: false,
  showdeliveryCost: false,
  showTax: true,
  SourceIdKey: {
    en: {
      WebUSJAccountCreation: '1012000',
      WebUSJEditCommunications: '1012004',
      WebUSJEditContactInfo: '1012005',
      WebUSJEditPersonalInfo: '1012006',
      WebUSJEditAddress: '1012007',
      WebUSJCreateorEditProfileTravelParty: '1018004',
      WebUSJLinkEntitlements: '1012029',
      WebUSJAccountDelete: '1032024',
      WebAccountDelete: '1012066',
      WebUpdatePassword: '1012063',
      WebUSHPaymentCard: '1012025',
    },
    ja: {
      WebUSJAccountCreation: '1012000',
      WebUSJEditCommunications: '1012004',
      WebUSJEditContactInfo: '1032005',
      WebUSJEditPersonalInfo: '1012006',
      WebUSJEditAddress: '1012007',
      WebUSJCreateorEditProfileTravelParty: '1012024',
      WebUSJLinkEntitlements: '1012029',
      WebUSJAccountDelete: '1032024',
      WebAccountDelete: '1012066',
      WebUpdatePassword: '1012063',
      WebUSHPaymentCard: '1012025',
    },
  },
  taxCodes: {
    display: false,
    NV_LIVE_ENT: '',
    SALES_TAX: '',
  },
  specialOffers: true,
  showGalaxyTickets: true,
  showAlphanumericLinkError: false,
  showICELinkInCoupon: false,
  displayDateByTimezone: true,
  timeZone: 'America/New_York',
  getTicketsLink: '',
  deleteRedirectURL: '',
  CHOICE_A_SECTION: '',
  CHOICE_B_SECTION: '',
  parkInfo: {
    TimeZone: 'America/Los_Angeles',
    abbreviatedMonthDayYearFormat: 'MMM dd, yyyy',
    MonthDayYearFormat: 'MM/dd/yyyy',
    MonthDayYearWithWeekday: 'MMM dd, yyyy (EEE)',
  },
  faviconUrl: 'assets/favicons/ush-favicon.ico',
  contentOidcTokenApi: false,
  shareQrEntitlementsAvailable: false,
  deleteAccountConfirmationFlow: false,
  fetchTravelPartyUrl: '/guests/{guestId}/travel-party-members',
  pageLabels: 'accounts',
  fontCssUrl: 'assets/fonts/_fonts.css',
  iconCssUrl: 'assets/icons/_font-face.css',
  sendParamsTravelParty: true,
  checkSaveTimeProperty: false,
  linkEntitlement: '/guests/{guest-id}/link-ticket',
};
export const environment = merge(shared_environment, ush_shared);
